import { useEffect, useState } from "react";
import { Dialog, DialogContent } from "@mui/material";
import { cardGateController } from "../../services/card-gate/card-gate-controller";
import { TrialCardGate } from "../../pages/subscription/TrialActivation";
import { useAppDispatch } from "../../store/hooks";
import { getProfile } from "../../store/slices/authSlice";

/**
 * ADR-TRIAL-card-gate (Фаза 5) — глобальный оверлей card-gate. Монтируется один раз
 * у корня приложения (внутри Router), подписан на {@link cardGateController}. Когда
 * axios-перехватчик ловит 402 TRIAL_CARD_REQUIRED, контроллер открывает эту модалку;
 * после привязки карты gate завершается `true` → перехватчик ПРОЗРАЧНО повторяет
 * исходный create/publish-запрос. Отмена (backdrop/кнопка) завершает gate `false` —
 * исходный запрос отклоняется штатно.
 */
export function CardGateProvider() {
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => cardGateController.subscribe(setOpen), []);

  const handleActivated = () => {
    // Карта застолблена на BE: обновляем профиль (freeEventsRemaining/карта),
    // затем завершаем gate — перехватчик повторит исходный запрос.
    void dispatch(getProfile());
    cardGateController.complete(true);
  };

  const handleCancel = () => cardGateController.complete(false);

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      maxWidth="sm"
      fullWidth
      aria-labelledby="card-gate-dialog"
    >
      <DialogContent sx={{ p: { xs: 2.5, sm: 4 } }}>
        <TrialCardGate onActivated={handleActivated} onCancel={handleCancel} />
      </DialogContent>
    </Dialog>
  );
}

export default CardGateProvider;
